import { IAppState } from '../../redux';
import { IRecommendedPackage } from '../../types/reducers/recommendedPackages';

export function selectRecommendedPackages(state: IAppState): IRecommendedPackage[] {
  return state.recommendedPackages.packages;
}
